export default "__VITE_ASSET__BDSyEqOG__"